import { render, staticRenderFns } from "./ManterDashboardFormacaoEscolaUnicaView.vue?vue&type=template&id=412d2bcf"
import script from "./ManterDashboardFormacaoEscolaUnicaView.vue?vue&type=script&lang=js"
export * from "./ManterDashboardFormacaoEscolaUnicaView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports